// ============================================================
// DEALIN MVP - Spinner / Loading Components
// ============================================================

import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
};

export const Spinner = ({ size = 'md', className }: SpinnerProps) => {
  return (
    <Loader2 className={cn('animate-spin text-blue-600', sizeClasses[size], className)} />
  );
};

export const PageLoading = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="relative flex items-center justify-center">
        <div className="absolute -inset-6 rounded-full border border-blue-200/40 animate-pulse" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-blue-500 border-r-blue-300 animate-spin" />
        <div className="h-16 w-16 rounded-full bg-white border border-slate-200 shadow-sm" />
        <div className="absolute inset-0 flex items-center justify-center gap-1">
          <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-bounce [animation-delay:-0.2s]" />
          <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-bounce [animation-delay:-0.1s]" />
          <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-bounce" />
        </div>
        <span className="sr-only">Loading</span>
      </div>
    </div>
  );
};

export const InlineLoading = ({ text = 'Caricamento...' }: { text?: string }) => {
  return (
    <div className="flex items-center gap-2 text-slate-600">
      <Spinner size="sm" />
      <span>{text}</span>
    </div>
  );
};

export default Spinner;

